import { AdminInput, Disclaimer, Div, lightTheme } from '@vgrubs/components';

/**
 * The backend validates this with class-validator and answers 400 above it, so
 * the field hard-caps typing instead of only colouring the counter.
 */
export const PICKUP_INSTRUCTIONS_MAX_LENGTH = 280;

/** `''` means "send nothing" - the callers turn it into `null` on save. */
type PickupInstructionsProps = {
  value: string;
  onChange: (value: string) => void;
  /** What an empty field ends up sending, spelled out for the admin. */
  helperText: string;
};

export const PickupInstructions = ({
  value,
  onChange,
  helperText,
}: PickupInstructionsProps) => (
  <Div>
    <AdminInput
      type="textarea"
      label="Pickup Instructions"
      tooltip="Sent to the delivery company (Motoclick, Cartwheel, Nash, First Delivery). The driver reads it when picking the order up."
      placeholder="Enter here"
      $textareaHeight={120}
      $resizable
      maxLength={PICKUP_INSTRUCTIONS_MAX_LENGTH}
      value={value}
      onChange={(e) =>
        onChange(e.target.value.slice(0, PICKUP_INSTRUCTIONS_MAX_LENGTH))
      }
    />
    <Disclaimer $m="0" $mt="20" $ml="24" $mr="24" $color={lightTheme.darkGray}>
      {helperText}
    </Disclaimer>
  </Div>
);
